import {
    PLATFORM_MAINTENANCE_ACTIVE,
    PLATFORM_MAINTENANCE_INACTIVE
} from '../actions/types';

const INIT_STATE = {
    active: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case PLATFORM_MAINTENANCE_ACTIVE:
            return { ...state, active: true };
        case PLATFORM_MAINTENANCE_INACTIVE:
            return { ...state, active: false };
        default:
            return state;
    }
};
